import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper teams2-wrapper',
    },
    page: {
      className: 'home-page teams2',
    },
    OverPack: {
      playScale: 0.3,
      className: '',
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: '团队成员',
        },
      ],
    },
    block: {
      className: 'block-wrapper',
      gutter: 72,
      children: [
        {
          name: 'block0',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
        {
          name: 'block1',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '韩勇',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
              },
            ],
          },
        },
        {
          name: 'block2',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
        {
          name: 'block3',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
        {
          name: 'block4',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '韩勇',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
              },
            ],
          },
        },
        {
          name: 'block5',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
        {
          name: 'block6',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
        {
          name: 'block7',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*njqxS5Ky7CQAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '韩勇',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: '语雀是一款优雅高效的在线文档编辑与协同工具。',
              },
            ],
          },
        },
        {
          name: 'block8',
          className: 'block',
          md: 8,
          xs: 24,
          image: {
            name: 'image',
            className: 'teams2-image',
            children: 'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*--rVR4hclJYAAAAAAAAAAABjARQnAQ',
          },
          titleWrapper: {
            className: 'teams2-textWrapper',
            children: [
              {
                name: 'title',
                className: 'teams2-title',
                children: '叶秀英',
              },
              {
                name: 'content',
                className: 'teams2-job',
                children: '公司+职位 信息暂缺',
              },
              {
                name: 'content1',
                className: 'teams2-content',
                children: 'Landing 是86links全新一代数据可视化解决方案。',
              },
            ],
          },
        },
      ],
    },
  },
};
